import React from 'react';
import './index.scss';
export const UnitLi = (props) => {
    return (
        <div className="pics-unit-li-box">
            <a
                hidden={
                    !props.imageUrls ||
                    (props.imageUrls &&
                        props.imageUrls.length <= 0 &&
                        !props.surfacePlot)
                }
                onClick={() => {
                    // window.open(
                    //     props.clickJump,
                    //     'target',
                    //     'width=375,height=667,left=10, top=10,toolbar=no, status=no, menubar=no, resizable=yes, scrollbars=yes'
                    // );
                }}
                className="pics-img">
                <img
                    src={
                        props.imageUrls && props.imageUrls.length > 0
                            ? props.imageUrls[0]['imageUrl']
                            : props.surfacePlot
                    }
                    alt=""
                />
                {/* <i className="img-count-box">{props.imageUrls.length}</i> */}
            </a>
            <div className="pics-info-box">
                <div className="pics-title-tag">
                    <h3>
                        <a
                            onClick={() => {
                                // window.open(
                                //     props.clickJump,
                                //     'target',
                                //     'width=375,height=667,left=10, top=10,toolbar=no, status=no, menubar=no, resizable=yes, scrollbars=yes'
                                // );
                            }}>
                            {substrTit(props.title)}
                        </a>
                    </h3>
                    <p className="pics-tag-box">
                        <span className="read-tag">
                            <i></i>
                            {props.browseSum}
                        </span>
                        <span className="like-tag">
                            <i></i>
                            {props.favourSum}
                        </span>
                        <span className="comment-tag">
                            <i></i>
                            {props.commentSum}
                        </span>
                        <span className="collect">
                            <i></i>
                            {props.collectSum}
                        </span>
                    </p>
                    <p className="pics-date">{props.releaseTime}
                     <span style={{paddingLeft: '20px'}}>
                        {props.groupName}
                     </span>
                     <span style={{paddingLeft: '20px', color: props.item.auditDescription ? 'red' : 'green'}}>
                        {props.statusName}
                        {props.item.auditDescription ? `:${props.item.auditDescription}` : ''}
                        </span>
                    </p>
                </div>
                <div className="right-tool">
                    {props.editCall && (
                        <span
                            className="edit-button"
                            onClick={() => props.editCall(props.id)}>
                            修改
                        </span>
                    )}
                    {props.delVideo && (
                        <span
                            className="del-button"
                            onClick={() => props.delVideo(props.id)}>
                            删除
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

function substrTit(title) {
    if (title.length > 113) {
        return title.substr(0, 113) + '...';
    }
    return title;
}
